module.exports = __webpack_public_path__ + "15b7f0185ca4da61163b3118b1d3f43f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-en.html
// module id = 1015
// module chunks = 0